import Signup from "../components/pages/Signup";
import Header from "../components/Header";

export default function SignupPage(){
    return(
        <>
            <Header
                heading="Signup to create an account"
                paragraph="Already have an account? "
                linkName="Login"
                linkUrl="/"
            />
            <Signup/>
        </>
    )
}